import * as types from "./types";


export const changeCountRoute = () => ({
    type: types.CHANGE_COUNT_ROUTE
})